import { stripNonDigits } from '@common/helpers/strip-non-digits';

export interface IAgentInfo {
  browser: {
    name: string;
    version: string;
  };
  device: {
    model: string;
    type: string;
    vendor: string;
  };
  os: {
    name: string;
    version: string;
  };
}

export class LiveChatMember {
  public constructor(
    readonly isNativeMfm: boolean = false,
    readonly firstName: string = null,
    readonly lastName: string = null,
    readonly number: string = null,
    readonly email: string = null,
    readonly info: string = null,
    readonly identity: string = null,
    readonly nickName: string = null,
    readonly maskedPhoneNumber: string = null,
    readonly origin: string = null,
    readonly agent: IAgentInfo = null,
    readonly sourceIp: string = null,
  ) {}

  get phoneNumber(): string {
    return stripNonDigits(this.maskedPhoneNumber).slice(-10); // +1 is ignored for USA;
  }

  get fullName(): string {
    return this.isNativeMfm || this.firstName || this.lastName
      ? [this.firstName, this.lastName].filter(Boolean).join(' ')
      : `Anonymous ${this.identity.substring(0, 2)}`;
  }

  get isntNativeMfm(): boolean {
    return !this.isNativeMfm;
  }
}
